import React from 'react';
import { Form } from 'react-bootstrap';

const LocationSelection = ({ locations, activeLocation, onSelectLocation, loadingSrc }) => {
  if (!locations?.length) {
    return (
      <div className="form-side-main">
        <div className="loading">
          {loadingSrc ? <img src={loadingSrc} alt="loading" /> : <span>Loading…</span>}
        </div>
      </div>
    );
  }

  return (
    <div className="form-side-main" >
      <h2> Step #1: Choose Your Location</h2>
      <div className="locations-box">
        <div className="loaction-box-inner">
          <div className="location-check">
            <Form>
              {locations.map((item, index) => (
                <div key={item.key || index} className="col-md-12">
                  <Form.Check
                    inline
                    label={item.key}
                    name="group1"
                    type="radio"
                    id={`location-${index}`}
                    checked={item.key === activeLocation}
                    onChange={() => onSelectLocation(item)}
                  />
                </div>
              ))}
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationSelection;
